import { store } from '@/store'
import { NavigationGuardNext, Route } from 'vue-router'

/**
 * AuthGuardNot
 * 
 * Checks if the user is NOT logged in. Handles redirects based on user state.
 * 
 * State 1 - User with zero memberships => Route to onboarding path based on verification status
 * State 2 - User with 1 membership => Route to tenant dashboard
 * State 3 - User with more than one membership => Route to tenant selection
**/
export default (to: Route, from, next: NavigationGuardNext) => {
    //  Get the current user
    const user = store.getters.user

    const reseller = to.query.token && to.query.uid

    // Get stripe payment information related to the user
    const stripeCustomerHasPayment = store.getters.stripeCustomerHasPayment

    //  IF this is a reseller link, log the user out just in case
    if (reseller) {
        store.commit('authUserSet', null)
        store.getters.appDebug && console.log('GUARD: auth-guard-not pass...')
        return next()
    }

    //  If there is no user, pass and continue.
    if (!user) {
        store.getters.appDebug && console.log('GUARD: auth-guard-not pass...')
        return next()
    }

    //  If there is a user but we are on the oauth-signin route, do nothing
    // if (user && to.path === '/oauth-signin') return next()

    //  Else, fail and reroute
    store.getters.appDebug && console.log('GUARD: auth-guard-not stop.')

    //  Get the user's membership count
    const memberships = store.getters.user.memberships

    //  If the user has zero tenants, route to onboarding path logic 
    if (memberships.length === 0) {
        //  Assemble the query params to forward to the next route
        const params = to.query ? `?${window.toUrlParams(to.query)}` : ''

        //  Ensure user has to repass 2FA to get the 2FA token or they will have to login twice which we want to prevent
        return next(`/register/verify${params}`)
    }

    // Else check to see if they have their two factor token 
    const twoFactorToken = localStorage.getItem('two_factor_token')

    // If they don't have two factor authenticated force them to the authentication page
    if (!twoFactorToken) return next('/signin/2fa')

    //  If the user has one membership, direct them to inbox
    if (memberships.length === 1) {

        store.dispatch('tenantGet', memberships[0].tenant_id).then(tenant => {
            // To handle goto for deeplink
            if(to.query.goto) {
                //  Assemble the query params to forward to the next route
                const params = to.query
                const { goto, ...newParams } = params
                return next(to.query.goto + '?' + window.toUrlParams(newParams))
            }
            //  Route to inbox
            return next('/inbox')
        })
    }

    //  If the user has more than one membership, direct them to memberships
    if (memberships.length > 1) {
        // To handle goto for deeplink
        if(to.query.goto) {
            //  Route to membership with query params
            return next(`/memberships${'?' + window.toUrlParams(to.query)}`)
        }
        return next('/memberships')
    }
}
